import Vue from 'vue'
import Router from 'vue-router'


import FormView from '@/FormView';
import FingoThankYouView from '@/FingoThankYouView';
import ZetosCalcView from '@/ZetosCalcView';
import ZetosResignView from '@/ZetosResignView';
import ZetosRejectView from '@/ZetosRejectView';
import RedirectView from '@/RedirectView';
import FingoClientView from '@/FingoClientView';
import FingoProposalView from '@/FingoProposalView';
import FingoTimeoutPage from '@/FingoTimeoutPage';
import ZetosPDFView from '@/ZetosPDFView';
import AuthologicReturn from "@/AuthologicReturn";
import TransactionlinkView from '@/TransactionlinkView';
import EasyCheckOkView from '@/EasyCheckOkView';

import { bus } from '@/main';


Vue.use(Router);

export const router = new Router({
  routes: [

   {
      path: '/',
      alias: ['/quickform', '/verifycode', '/fullform', '/kontox'],
      name: 'ZetosFormView',
      component: FormView

    },
    {
      path: '/authologic',
      name: 'AuthologicReturn',
      component: AuthologicReturn
    },
    {
      path: '/thankyou',
      name: 'FingoThankYouView',
      component: FingoThankYouView
    },

    {
      path: '/pdf',
      name: 'ZetosPDFView',
      component: ZetosPDFView
    },


    {
      path: '/client',
      name: 'FingoClientView',
      component: FingoClientView
    },

    {
      path: '/proposal',
      name: 'FingoProposalView',
      component: FingoProposalView
    },

    {
      path: '/resign',
      name: 'ZetosResignView',
      component: ZetosResignView
    },

    {
      path: '/calc',
      name: 'ZetosCalcView',
      component: ZetosCalcView
    },

    {
      path: '/rej',
      //name: 'ZetosRejectView',
     // component: ZetosRejectView
      name: 'RedirectView',
      component: RedirectView
    },

    {
      path: '/redirect',
      name: 'RedirectView',
      component: RedirectView
    },


    {
      path: '/t10l',
      name: 'TransactionlinkView',
      component: TransactionlinkView
    },

    {
      path: '/aisok',
      name: 'EasyCheckOkView',
      component: EasyCheckOkView
    },

    {
      path: '/pending',
      name: 'FingoTimeoutPage',
      component: FingoTimeoutPage
    },

    {
      path: '*',
      redirect: '/'
    }

  ]
});



router.beforeEach((to, from, next) => {

  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/', '/quickform', '/fullform', '/verifycode', '/kontox','/authologic', '/thankyou', '/pdf', '/t10l', '/aisok',  '/rej', '/redirect', '/proposal', '/resign', '/pending', '/calc'];

  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');



  // default to client view after login
/*  if (loggedIn && !to.path.match(/(client|\/|fullform|rej|thankyou|proposal|pending)$/)) {


    return next('/client');
  }

  else */


  if (!loggedIn && authRequired ) {


    bus.$emit('login_dialog');

    return next('/');
  }


  next();



});



// WEBPACK FOOTER //
// ./src/router/index.js